/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
import { ContextAPI } from './api/context';
/**
 * Entrypoint for context API
 * @since 1.0.0
 */
export const context = ContextAPI.getInstance();
